
import { useState, useEffect } from 'react';

// Default intro text - matches what's in the email template
const DEFAULT_INTRO_TEXT = "I juni 2025 lanseres Briefr.no, en ny formidler av nyheter, aktualitet og bredt samfunnsliv, med særlig fokus på formidling fra fageksperter. Vårt format tillater lengre og grundigere resonnementer; ditt svar publiseres i utgangspunktet ordrett, uavhengig av lengde, etter korrektursjekk. Vi gir deg beskjed dersom vi mot formodning finner det aktuelt å foreta endringer. Du mottar et varsel på epost når artikkelen er publisert.";

const STORAGE_KEY = 'briefr_intro_text';

export const useIntroText = () => {
  // Initialize from localStorage or use default
  const [introText, setIntroText] = useState(() => {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored || DEFAULT_INTRO_TEXT;
    }
    return DEFAULT_INTRO_TEXT;
  });

  // Function to update the intro text and persist to localStorage
  const updateIntroText = (newText: string) => {
    const text = newText || DEFAULT_INTRO_TEXT;
    setIntroText(text);
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, text);
    }
  };

  // Reset to default text
  const resetToDefault = () => {
    setIntroText(DEFAULT_INTRO_TEXT);
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, DEFAULT_INTRO_TEXT);
    }
  };

  return {
    introText,
    updateIntroText,
    resetToDefault,
    DEFAULT_INTRO_TEXT
  };
};
